import { type FC, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { AddRemoveButtons } from '../../../../../../common/components';
import type { UUIDType } from '../../../../../../common/utils';
import type { AlgorithmJoinsAndMappingsGraphValidFormDataType } from '../../../schema/types';

interface AddAlgorithmSourceNodeItemButtonProps {
  nodeId: UUIDType;
  nodeIndex: number;
}

export const AddAlgorithmSourceNodeItemButton: FC<
  AddAlgorithmSourceNodeItemButtonProps
> = (props) => {
  const { nodeId, nodeIndex } = props;

  const { getValues, setValue } =
    useFormContext<AlgorithmJoinsAndMappingsGraphValidFormDataType>();

  const addItem = useCallback(() => {
    const name = `nodes.${nodeIndex}.data.items` as const;
    setValue(
      `${name}.${getValues(name).length}`,
      { dimensionCode: '' },
      { shouldDirty: true },
    );
  }, [nodeIndex, getValues, setValue]);

  return (
    <AddRemoveButtons
      id={`join-node-${nodeId}-add-item`}
      onClickAdd={addItem}
    />
  );
};
